module.exports = __webpack_public_path__ + "static/media/chat-icon-rcp.b14c457a.jpg";